import React, { useEffect, useState } from "react";
import axios from "axios";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";

const HallOfFameContainer = styled.div`
  max-width: 800px;
  margin: 2rem auto;
  padding: 1.5rem;
`;

const SeasonCard = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  margin-bottom: 1rem;
  padding: 1rem 1.5rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.01);
  }
`;

const SeasonHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 1.2rem;
`;

const LeaderList = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 0.75rem;
`;

const LeaderItem = styled.li`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #ddd;
  &:last-child {
    border-bottom: none;
  }
`;

const Medal = styled.span`
  font-size: 1.3rem;
  margin-right: 0.5rem;
`;

const ExpandIcon = styled.span`
  font-size: 1.2rem;
  color: #666;
`;

const HallOfFame = () => {
  const [seasons, setSeasons] = useState([]);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    const fetchSeasons = async () => {
      try {
        const { data } = await axios.get("/api/hall-of-fame");
        setSeasons(data);
      } catch (err) {
        console.error("Error fetching Hall of Fame data:", err);
      }
    };
    fetchSeasons();
  }, []);

  const toggleExpand = (year) => {
    setExpanded(expanded === year ? null : year);
  };

  const getMedal = (rank) => {
    if (rank === 1) return <Medal>🥇</Medal>;
    if (rank === 2) return <Medal>🥈</Medal>;
    if (rank === 3) return <Medal>🥉</Medal>;
    return null;
  };

  return (
    <HallOfFameContainer>
      <h1>🏆 Hall of Fame</h1>
      {seasons.length === 0 ? (
        <p>No past seasons available yet.</p>
      ) : (
        seasons.map((season) => (
          <SeasonCard
            key={season.year}
            onClick={() => toggleExpand(season.year)}
          >
            <SeasonHeader>
              <span>{season.year} Season</span>
              <ExpandIcon>
                {expanded === season.year ? "▲" : "▼"}
              </ExpandIcon>
            </SeasonHeader>

            <AnimatePresence initial={false}>
              {expanded === season.year && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <LeaderList>
                    {season.leaderboard.map((player) => (
                      <LeaderItem key={player._id}>
                        <span>
                            {player.rank}. {player.username} {getMedal(player.rank)}
                        </span>
                        <span>
                            <strong>{player.score} pts</strong> | {/* existing score */}
                            {player.conversionRate} {/* new conversion rate */}
                        </span>
                        </LeaderItem>
                    ))}
                  </LeaderList>
                </motion.div>
              )}
            </AnimatePresence>
          </SeasonCard>
        ))
      )}
    </HallOfFameContainer>
  );
};

export default HallOfFame;
